// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rw5--InputErrorIndicator--InputErrorIcon{display:inline-flex;width:auto!important;align-self:center;color:var(--uikit-color-error)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"themeBase": "InputErrorIndicator",
	"InputErrorIcon": "rw5--InputErrorIndicator--InputErrorIcon"
};
module.exports = ___CSS_LOADER_EXPORT___;
